import { render, staticRenderFns } from "./VulnDetailsTableRow.vue?vue&type=template&id=0f88d9a1"
import script from "./VulnDetailsTableRow.vue?vue&type=script&lang=js"
export * from "./VulnDetailsTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports